<template>
    <header :class="'head-nav ' + (isCollapse ? 'spread' : '')">
        <div class='logo-container'>
            <i class="iconfont icon-jigoulogo"></i>
            <span class='head-title'>{{userInfo.company}}</span>
        </div>

        <div>
            <span
                v-if="notiferShow"
                style="cursor: pointer"
                @click="toNotify"
            >
            <i
                    class="el-icon-bell"
                    style="padding: 10px;font-size: 18px;position: relative;top: 4px;"
                />
            </span>
            <el-badge class="notify-dot">
                <i
                    class="el-icon-user"
                    style="font-size: 18px;"
                />
            </el-badge>
            <div class='head-welcome username'>
                <el-dropdown trigger="click" placement="bottom-start" @command="userDropdownClick">
                    <span class="el-dropdown-link">
                        <span class='head-wel_name'>Hi,</span>
                        <span class='head-wel_name'>{{userInfo.contact_name}}</span>
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command='/index/info'>基本信息</el-dropdown-item>
                        <el-dropdown-item command='logout'>退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <special-announcement
            v-if="showSpecialAnnouncement"
            :visible="isAnnouncementModalVisible"
            @update:status="handleStatus"
        ></special-announcement>
        <announcement
            v-else
            :visible="isAnnouncementModalVisible"
            @update:status="handleStatus"
        ></announcement>
    </header>
</template>
<script >
import router from '@/router'
import Announcement from '@/components/Announcement.vue'
import SpecialAnnouncement from '@/components/Special_Announcement.vue'

export default {
    name: 'head-nav',
    components: { Announcement, SpecialAnnouncement },
    inject: ['back', 'goPage', 'tel'],
    data () {
        return {
            userInfo: {}
        }
    },
    mounted () {
        this.getUserInfo()
    },
    computed: {
        isCollapse () {
            return this.$store.state.isCollapse
        },
        isAnnouncementModalVisible () {
            return this.userInfo.is_greement === 1
        },
        notiferShow () {
            return this.userInfo.is_greement !== 0 && Number(this.userInfo.user_id) !== 1089
        },
        showSpecialAnnouncement () {
            return Number(this.userInfo.user_id) === 1089 && this.userInfo.is_greement === 1
        }
    },
    methods: {
        userDropdownClick (command) {
            if (command !== 'logout') {
                this.goPage(command)
            } else {
                window.localStorage.removeItem('token')
                router.replace('/login')
            }
        },
        getUserInfo () {
            try {
                if (window.localStorage.getItem('USERINFO')) {
                    this.userInfo = JSON.parse(window.localStorage.getItem('USERINFO'))
                } else {
                    throw new Error('获取本地userInfo失败')
                }
            } catch (err) {
                this.$http.get('/api/user/userinfo')
                    .then(res => {
                        if (res.code === 0) {
                            this.userInfo = res.data
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
        },
        handleStatus (status) {
            switch (status) {
            case true:
                this.$http.get('/api/user/setagreementread')
                    .then(res => {
                        if (res.code === 0) {
                            this.userInfo.is_greement = 2
                            window.localStorage.setItem('USERINFO', JSON.stringify(this.userInfo))
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                    })
                break
            case false:
                window.localStorage.removeItem('token')
                router.replace('/login')
                break
            }
        },
        toNotify () {
            console.log('toNotify')
            this.goPage('/index/info/notification')
        }
    }
}
</script>

<style scoped lang="scss">
    @import '../assets/style/index.scss';
</style>
